import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi'

/**
 * API for managing ticket assignment
*/
const create = () => {

    const api = BaseApi.create({ timeout: 120000 }); // longer timeout to accommodate potential long running calls to find an associate/assign a ticket.

    const getExistingPostalCode = () => api.get(ApiPaths.ASSIGN_POSTAL);

    const setPostalCode = (postalCode) => api.post(ApiPaths.ASSIGN_POSTAL, { postalCode });

    const assignTickets = (associateId, officeId) => api.post(ApiPaths.ASSIGN, { associateId, officeId });

    // Return back a collection of functions
    return {
        getExistingPostalCode, setPostalCode, assignTickets
    }
}

// let's return back our create method as the default.
export default {
    create    
}